import Spinner from "@albertsons/uds/molecule/Spinner";

const LoadingIndicator = () => (
  <div className="absolute top-0 left-0.5 scale-75 [&>div>div]:!border-gray-700">
    <Spinner size="xs" />
  </div>
);

export default LoadingIndicator;
